import React from "react";
import InlineLoader from "rsuite/Loader";

export default function Loader({ isInline }) {
  if (isInline) {
    return <span style={{ marginLeft: "2px" }}><InlineLoader /></span>
  }
  return <div className="loader" />;
}
